import { RequiredFieldMissingError } from './errorsClient';

export function requireFieldNotEmpty<T>(arg: T | undefined): Exclude<T, 0> {
  // NOTE: grpc sets all fields not set by the sender to their respective default value
  // therefore arg === '' may indicate a missing field
  // (don't use this function for values where '' is a valid value)
  // see https://developers.google.com/protocol-buffers/docs/proto3#default
  if (arg === undefined || arg === '' || arg === 0) {
    throw new RequiredFieldMissingError();
  }
  if (Array.isArray(arg) && arg.length === 0) {
    throw new RequiredFieldMissingError();
  }
  return arg as Exclude<T, 0>;
}

type Enum = Record<string | number, string | number>;

export function knownEnumOrDefault<T extends Enum>(value: T[keyof T], enumObject: T): T[keyof T] {
  const enumValues = Object.values(enumObject);
  if (enumValues.includes(value)) {
    return value;
  }
  // Using the protobuf notion of "default", i.e. the first value. By convention, this is
  // a dedicated UNKNOWN value for all our enums.
  // This goes through the reverse mapping to get the actual entry with index 0.
  const firstValue = enumObject[0]!;
  return enumObject[firstValue] as T[keyof T];
}
